module.exports = __webpack_public_path__ + "static/media/magic bricks chice.54d97bb0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/magic bricks chice.gif
// module id = 351
// module chunks = 0